<template>
	<div>
	<ValidationProvider v-slot="v" :rules="{ regex: /^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}$/, required_if: { formType } }" :name="componentId">
		<b-form-group :state="false" :invalid-feedback="v.errors[0]">
			<b-row class="mt-3" align-h="center">
	  			<b-col class="form-inline" cols="10" lg="5">
		  				<b-row align-v="center" no-gutters>
	  					<b-col class="mr-2">
	        				<label class="text-nowrap" for="report-time">{{ title }}</label>
	        			</b-col>
	        			<b-col class="mr-1">
							<span id="date-picker-input">
							<el-date-picker 
								type="datetime" 
								placeholder="2009-10-29 01:08" 
								value-format="yyyy-MM-dd HH:mm" 
								format="yyyy-MM-dd HH:mm" 
								v-model="reportTime" 
								:picker-options="pickerOptions">
							</el-date-picker>
							</span>
							<b-tooltip target="date-picker-input" variant="info" triggers="hover">
							    Töltse ki gépeléssel, vagy válasszon időpontot a naptárról és az óráról.
  							</b-tooltip>
						</b-col>
						<b-col>
							<b-button size="sm" variant="primary" @click="setNow" class="now-button">most</b-button>
		        		</b-col>
	        		</b-row>
	  			</b-col>
			</b-row>
		</b-form-group>
	</ValidationProvider>
	</div>
</template>

<script>
	import { ValidationProvider, extend } from 'vee-validate'
	import { regex } from 'vee-validate/dist/rules'
	import { messages } from '@/texts/messages'
	import { DateTime } from 'luxon'

	extend('required_if', {
		params: ['formType'],
		validate(value, { formType }) {
			return formType !== 'adequate' || ['', null, undefined].indexOf(value) === -1
		},
		message: messages.field_is_required,
		computesRequired: true
	})

	extend('regex', {
		...regex,
		message: messages.datetime_not_valid_format
	})

	export default {
		name: 'date-with-now',
		components: {
			ValidationProvider
		},
		props: ['title', 'componentId', 'property'],
		data() {
			return {
				pickerOptions: {
					disabledDate: this.isDateInTheFuture,
					firstDayOfWeek: 1
				}
			}
		},
		computed: {
			reportTime: {
				get() {
					return this.$store.state.form[this.property]
				},
				set(value) {
					this.$store.commit('setFormProperty', { property: this.property, value })
				}
			},
			formType() {
				return this.$store.state.form.type
			}
		},
		methods: {
			isDateInTheFuture(date) {
				return DateTime.fromJSDate(date).toMillis() > DateTime.local().toMillis()
			},
			setNow() {
				this.reportTime = DateTime.local().toFormat('yyyy-MM-dd HH:mm')
			}
		}		
	}
</script>
<style scoped>

label {
	font-weight: bold;
}
</style>